<div mat-dialog-content>
  {{message}}
</div>
<div mat-dialog-actions>
  <button mat-button style="background-color: #17a1fe; color: white" (click)="onOkClick()">Ok</button>
  <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button> -->
</div>